import { utilBuildings } from "../../../../../utils/utilBuildings";
import { createPathSelectBuildingMaxLevel } from "../../../path/createPathSelectBuildingMaxLevel";
import { selectAcresAvailable } from "../../../selectors/selectAcresAvailable";
export var pathSelectAcreNotProducingMaxLevelUseHumus = function (action, state$, deps) {
    return createPathSelectBuildingMaxLevel(function () {
        var acresAvailable = selectAcresAvailable(state$.value);
        return acresAvailable.filter(utilBuildings.isNotProducing);
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/use-humus/paths/pathSelectAcreNotProducingMaxLevelUseHumus.ts
// module id = 2394
// module chunks = 3